export interface VasTypeActionTypes {
  type: VasTypeActions;
  payload?: any;
}

export enum VasTypeActions {
  CREATE_VAS_TYPE = "CREATE_VAS_TYPE",
  GET_VAS_TYPE_LIST = "GET_VAS_TYPE_LIST",
  SET_VAS_TYPE_LIST = "SET_VAS_TYPE_LIST",
  SET_VAS_TYPE_LIST_PAGE_COUNT = "SET_VAS_TYPE_LIST_PAGE_COUNT",
  GET_VAS_TYPE_DATA_BY_ID = "GET_VAS_TYPE_DATA_BY_ID",
  SET_VAS_TYPE_DATA_BY_ID = "SET_VAS_TYPE_DATA_BY_ID",
  EDIT_VAS_TYPE_DATA_BY_ID = "EDIT_VAS_TYPE_DATA_BY_ID",
}
